import pLimit from 'p-limit';

/**
 * C:\VUE3\platform\src\utils\concurrency.js
 * uploadLimiter: 브라우저 탭 하나(=클라이언트 인스턴스) 내에서 동시에 실행할
 * 비동기 작업(여기서는 파일 업로드)을 제한하는 세마포어(semaphore) 역할을 합니다.
 *
 * pLimit(30)을 호출하면:
 *  - 동일 탭/인스턴스 내에서 **최대 30개의** 비동기 작업을 병렬로 실행할 수 있습니다.
 *  - 31번째 작업은 **앞선 작업 중 하나가 완료**될 때까지 **대기** 상태가 됩니다.
 *  - 이렇게 하면 탭 내부 메모리·네트워크 과부하를 방지하고, 브라우저 리소스를 안정적으로 사용할 수 있습니다.
 *
 * **중요 포인트**
 * 1. 이 제한은 **프론트엔드 단**(각 브라우저 탭)에서만 적용됩니다.
 *    - 같은 사용자가 다른 탭을 열면, 각 탭마다 별도의 uploadLimiter 인스턴스가 생겨
 *      탭별로 각각 30개씩 동시 업로드가 허용됩니다.
 *    - 다른 사용자가 별도의 브라우저에서 접속해도 마찬가지로, 그 브라우저 탭에도
 *      uploadLimiter가 동작합니다.
 *
 * 2. 서버 전체(모든 사용자 합산) 동시 업로드를 제어하려면,
 *    백엔드(FastAPI 등)에서 큐 또는 세마포어 로직을 별도로 구현해야 합니다.
 *
 * 3. 필요 시 숫자(30)를 환경변수로 옮겨 유연하게 조정 가능합니다.
 */
export const uploadLimiter = pLimit(30);
